/** 页面 TDK：英文完整；其它语言可先与英文一致或略改标题，避免编码问题 */
const E = (title, description, keywords) => ({ title, description, keywords });

export const tdk = {
	home: {
		en: E(
			'GBWhatsApp APK Download V18.80 Latest Version 2026',
			'Download GBWhatsApp APK latest version 2026 safely. Explore MOD features, installation guide, PC/Web support, privacy settings, and top GB WhatsApp alternatives.',
			'gbwhatsapp, gb whatsapp, gb whatsapp download'
		),
		in: E(
			'GBWhatsApp APK डाउनलोड V18.80 नवीनतम संस्करण 2026',
			'GBWhatsApp वह अतिरिक्त देता है जो लोग WhatsApp मॉड में चाहते हैं: बेहतर गोपनीयता (ऑनलाइन, टिक, टाइपिंग), थीम व UI, स्टेटस टूल, कई बिल्ड पर ऑटो-रिप्लाई व शेड्यूल, अक्सर बड़ी मीडिया सीमा व दो नंबर—साथ में साइडलोड जोखिम व सेवा की शर्तों पर ईमानदार नोट।',
			'GBWhatsApp, gb whatsapp, gb whatsapp download, gbwhatsapp apk, whatsapp mod'
		),
		es: E(
			'Descargar GBWhatsApp APK V18.80 última versión 2026',
			'GBWhatsApp añade lo que muchos buscan en un mod: privacidad fina (en línea, ticks, escribiendo), temas y UI, herramientas de estados, auto-respuesta y programación en muchas builds, a menudo más techo de medios y flujos con dos números—más notas honestas sobre sideload y términos.',
			'GBWhatsApp, gb whatsapp, descargar gb whatsapp, gbwhatsapp apk, whatsapp mod'
		),
		pt: E(
			'Baixar GBWhatsApp APK V18.80 última versão 2026',
			'GBWhatsApp traz o que as pessoas querem num mod: privacidade fina (online, ticks, digitando), temas e UI, ferramentas de status, auto-resposta e agendamento em muitas builds, muitas vezes mais teto de mídia e dois números—com notas honestas sobre sideload e termos.',
			'GBWhatsApp, gb whatsapp, baixar gb whatsapp, gbwhatsapp apk, whatsapp mod'
		),
		id: E(
			'Download GBWhatsApp APK V18.80 versi terbaru 2026',
			'GBWhatsApp menambahkan yang dicari dari mod WhatsApp: privasi lebih halus (online, centang, mengetik), tema dan UI, alat status, balasan otomatis dan penjadwalan di banyak build, sering batas media lebih besar dan dua nomor—plus catatan jujur tentang sideload dan syarat.',
			'GBWhatsApp, gb whatsapp, download gb whatsapp, gbwhatsapp apk, whatsapp mod'
		),
	},
	download: {
		en: E(
			'Download GBWhatsApp APK & MODs Latest Version 2026',
			'Download GBWhatsApp APK and WhatsApp MODs like FMWhatsApp, YoWhatsApp, OGWhatsApp safely. Get the latest versions with the installation guide.',
			'gbwhatsapp download, gb whatsapp apk, whatsapp mod apk download'
		),
		in: E(
			'GBWhatsApp APK और MODs डाउनलोड 2026',
			'GBWhatsApp और लोकप्रिय MODs को डाउनलोड करने से पहले maintainer line, signature, checksum, पुराना rollback build और install guide को समझें।',
			'gbwhatsapp download, gb whatsapp apk, whatsapp mod apk download'
		),
		es: E(
			'Descargar GBWhatsApp APK y MODs 2026',
			'Descarga GBWhatsApp y MODs populares con guia de instalacion.',
			'gbwhatsapp download, gb whatsapp apk, whatsapp mod apk download'
		),
		pt: E(
			'Baixar GBWhatsApp APK e MODs 2026',
			'Baixe GBWhatsApp e MODs com guia de instalacao.',
			'gbwhatsapp download, gb whatsapp apk, whatsapp mod apk download'
		),
		id: E(
			'Download GBWhatsApp APK & MODs 2026',
			'Unduh GBWhatsApp dan MOD populer dengan panduan instalasi.',
			'gbwhatsapp download, gb whatsapp apk, whatsapp mod apk download'
		),
	},
	oldVersions: {
		en: E(
			'Old Versions of GBWhatsApp APK',
			'Older GBWhatsApp APK archive: rollback reasons, version history, legacy downloads, feature differences, Android compatibility, known issues, and FAQs.',
			'gbwhatsapp old version, gb whatsapp apk archive, download gbwhatsapp apk older'
		),
		in: E('GBWhatsApp के पुराने संस्करण', 'पुराने GBWhatsApp APK archive, rollback कारण, compatibility, known issues और FAQ।', 'gbwhatsapp old version'),
		es: E('Versiones antiguas de GBWhatsApp', 'Archivo de APK antiguos de GBWhatsApp: rollback, compatibilidad, problemas conocidos y FAQ.', 'gbwhatsapp old version'),
		pt: E('Versões antigas do GBWhatsApp', 'Arquivo de APKs antigos do GBWhatsApp com rollback, compatibilidade, problemas conhecidos e FAQ.', 'gbwhatsapp old version'),
		id: E('Versi lama GBWhatsApp', 'Arsip APK lama GBWhatsApp: alasan rollback, kompatibilitas, masalah umum, dan FAQ.', 'gbwhatsapp old version'),
	},
	forPc: {
		en: E(
			'GBWhatsApp for PC / Windows',
			'Use GBWhatsApp on Windows: emulators, system requirements, installation steps, Web workflows, desktop features, common PC issues, and FAQs.',
			'gbwhatsapp for pc, gb whatsapp windows, gbwhatsapp pc install'
		),
		in: E('PC / Windows के लिए GBWhatsApp', 'Windows पर GBWhatsApp उपयोग: emulator, requirements, install steps, Web workflow, desktop features और common issues.', 'gbwhatsapp for pc'),
		es: E('GBWhatsApp para PC / Windows', 'Usa GBWhatsApp en Windows con emuladores, requisitos, instalación, funciones de escritorio y problemas comunes.', 'gbwhatsapp for pc'),
		pt: E('GBWhatsApp para PC / Windows', 'Use o GBWhatsApp no Windows com emuladores, requisitos, instalação, recursos de desktop e problemas comuns.', 'gbwhatsapp for pc'),
		id: E('GBWhatsApp untuk PC / Windows', 'Gunakan GBWhatsApp di Windows dengan emulator, persyaratan, langkah instalasi, fitur desktop, dan masalah umum.', 'gbwhatsapp for pc'),
	},
	forWeb: {
		en: E(
			'GBWhatsApp Web Guide',
			'Use GBWhatsApp Web: access steps, supported browsers, Web features vs APK, phone sync, privacy on shared PCs, troubleshooting, and FAQs.',
			'gbwhatsapp web, gb whatsapp web guide, gbwhatsapp web login'
		),
		in: E('GBWhatsApp Web गाइड', 'GBWhatsApp Web access, browser support, sync, privacy on shared PCs, troubleshooting और FAQ।', 'gbwhatsapp web'),
		es: E('Guía de GBWhatsApp Web', 'Acceso a GBWhatsApp Web, navegadores compatibles, sincronización, privacidad y solución de problemas.', 'gbwhatsapp web'),
		pt: E('Guia do GBWhatsApp Web', 'Acesso ao GBWhatsApp Web, navegadores suportados, sincronização, privacidade e solução de problemas.', 'gbwhatsapp web'),
		id: E('Panduan GBWhatsApp Web', 'Akses GBWhatsApp Web, browser yang didukung, sinkronisasi, privasi, troubleshooting, dan FAQ.', 'gbwhatsapp web'),
	},
	features: {
		en: E(
			'GBWhatsApp Features – Privacy, Themes, Media & Automation',
			'A practical map of GBWhatsApp value: privacy signal control, multi-account workflows, media/status advantages, automation boundaries, and risk-aware usage patterns by maintainer line.',
			'gbwhatsapp features, gb whatsapp privacy, whatsapp mod features, gbwhatsapp themes, auto reply gbwhatsapp'
		),
		in: E('GBWhatsApp सुविधाएँ', 'GBWhatsApp का वास्तविक value map: privacy control, themes, media/status, automation, multi-account workflow और risk-aware usage।', 'gbwhatsapp features'),
		es: E('Funciones de GBWhatsApp', 'Mapa práctico del valor de GBWhatsApp: privacidad, temas, medios, automatización y flujos multi-cuenta.', 'gbwhatsapp features'),
		pt: E('Recursos do GBWhatsApp', 'Mapa prático do valor do GBWhatsApp: privacidade, temas, mídia, automação e fluxos multi-conta.', 'gbwhatsapp features'),
		id: E('Fitur GBWhatsApp', 'Peta nilai praktis GBWhatsApp: kontrol privasi, tema, media, otomasi, dan alur multi-akun.', 'gbwhatsapp features'),
	},
	modsIndex: {
		en: E(
			'Popular WhatsApp MODs – FM, Yo, OG, Blue',
			'FMWhatsApp, YoWhatsApp, OGWhatsApp, BlueWhatsApp overview and download context.',
			'whatsapp mod, fmwhatsapp, yowhatsapp, ogwhatsapp'
		),
		in: E('लोकप्रिय WhatsApp MODs', 'FMWhatsApp, YoWhatsApp, OGWhatsApp और BlueWhatsApp overview, अंतर और download context।', 'whatsapp mod'),
		es: E('MODs populares de WhatsApp', 'Resumen de FMWhatsApp, YoWhatsApp, OGWhatsApp y BlueWhatsApp con contexto de descarga.', 'whatsapp mod'),
		pt: E('MODs populares do WhatsApp', 'Visão geral de FMWhatsApp, YoWhatsApp, OGWhatsApp e BlueWhatsApp com contexto de download.', 'whatsapp mod'),
		id: E('MOD WhatsApp populer', 'Ringkasan FMWhatsApp, YoWhatsApp, OGWhatsApp, dan BlueWhatsApp dengan konteks unduhan.', 'whatsapp mod'),
	},
	blogIndex: {
		en: E(
			'GBWhatsApp Blog – Guides, Safety & Updates',
			'Long-form guides: safety, updates, privacy, MOD comparisons, fixes.',
			'gbwhatsapp blog, gb whatsapp guide'
		),
		in: E('GBWhatsApp ब्लॉग', 'Long-form guides: safety, updates, privacy settings, MOD comparisons, migration और troubleshooting articles.', 'gbwhatsapp blog'),
		es: E('Blog de GBWhatsApp', 'Guías largas sobre seguridad, actualizaciones, privacidad, comparativas de MODs y solución de problemas.', 'gbwhatsapp blog'),
		pt: E('Blog do GBWhatsApp', 'Guias completos sobre segurança, updates, privacidade, comparações de MODs e troubleshooting.', 'gbwhatsapp blog'),
		id: E('Blog GBWhatsApp', 'Panduan panjang tentang keamanan, update, privasi, perbandingan MOD, migrasi, dan troubleshooting.', 'gbwhatsapp blog'),
	},
	about: {
		en: E(
			'About gbwhtas.com',
			'Independent editorial mission, GBWhatsApp and MOD coverage standards, disclaimers, and links to features, downloads, blog, and policies.',
			'about gbwhatsapp site'
		),
		in: E('gbwhtas.com के बारे में', 'Independent editorial mission, GBWhatsApp/MOD coverage standards, disclaimers और site navigation context.', 'about gbwhatsapp'),
		es: E('Acerca de gbwhtas.com', 'Misión editorial independiente, estándares de cobertura de GBWhatsApp y MODs, y descargos.', 'about gbwhatsapp'),
		pt: E('Sobre gbwhtas.com', 'Missão editorial independente, padrões de cobertura de GBWhatsApp/MODs e avisos legais.', 'about gbwhatsapp'),
		id: E('Tentang gbwhtas.com', 'Misi editorial independen, standar cakupan GBWhatsApp/MOD, dan penafian situs.', 'about gbwhatsapp'),
	},
	contact: {
		en: E(
			'Contact gbwhtas.com',
			'How to report corrections, what to include in messages, DMCA vs editorial contact, and links to policies and site sections.',
			'contact gbwhatsapp'
		),
		in: E('gbwhtas.com संपर्क', 'Correction reports, legal notices, privacy questions और editorial contact instructions।', 'contact gbwhatsapp'),
		es: E('Contacto de gbwhtas.com', 'Correcciones, avisos legales, dudas de privacidad y contacto editorial.', 'contact gbwhatsapp'),
		pt: E('Contato do gbwhtas.com', 'Correções, avisos legais, dúvidas de privacidade e contato editorial.', 'contact gbwhatsapp'),
		id: E('Kontak gbwhtas.com', 'Laporan koreksi, pemberitahuan hukum, pertanyaan privasi, dan kontak editorial.', 'contact gbwhatsapp'),
	},
	privacy: {
		en: E(
			'Privacy Policy – gbwhtas.com',
			'Scope, data we collect, cookies, sharing, retention, and links to terms and contact for privacy questions.',
			'gbwhatsapp privacy policy'
		),
		in: E('गोपनीयता नीति', 'Scope, data collection, cookies, sharing, retention और privacy contact details on gbwhtas.com।', 'privacy policy'),
		es: E('Política de privacidad', 'Ámbito, datos que recopilamos, cookies, conservación y contacto de privacidad en gbwhtas.com.', 'privacy policy'),
		pt: E('Política de privacidade', 'Escopo, coleta de dados, cookies, retenção e contato de privacidade no gbwhtas.com.', 'privacy policy'),
		id: E('Kebijakan privasi', 'Cakupan, data yang dikumpulkan, cookie, retensi, dan kontak privasi di gbwhtas.com.', 'privacy policy'),
	},
	terms: {
		en: E(
			'Terms of Service – gbwhtas.com',
			'Agreement, permitted use, disclaimers on MODs and third-party software, liability limits, and links to privacy and DMCA.',
			'gbwhatsapp terms'
		),
		in: E('सेवा की शर्तें', 'Agreement, permitted use, disclaimers for MOD and third-party software, liability limits, and links to privacy and DMCA.', 'terms of service'),
		es: E('Términos del servicio', 'Acuerdo, uso permitido, descargos sobre MODs y software de terceros, y límites de responsabilidad.', 'terms of service'),
		pt: E('Termos de serviço', 'Acordo, uso permitido, avisos sobre MODs e software de terceiros, e limites de responsabilidade.', 'terms of service'),
		id: E('Ketentuan layanan', 'Perjanjian, penggunaan yang diizinkan, penafian untuk MOD/perangkat lunak pihak ketiga, dan batas tanggung jawab.', 'terms of service'),
	},
	dmca: {
		en: E(
			'DMCA – gbwhtas.com',
			'Copyright notice requirements, counter-notifications, repeat infringer policy, processing expectations, and links to About, contact, and homepage.',
			'dmca gbwhatsapp'
		),
		in: E('DMCA', 'Copyright notice requirements, counter-notice process, repeat policy and expected review flow on gbwhtas.com.', 'dmca'),
		es: E('DMCA', 'Requisitos de aviso de copyright, contraaviso, política para reincidentes y proceso de revisión.', 'dmca'),
		pt: E('DMCA', 'Requisitos de notificação de copyright, contranotificação, política para reincidentes e fluxo de revisão.', 'dmca'),
		id: E('DMCA', 'Persyaratan pemberitahuan hak cipta, kontra-notice, kebijakan pelanggar berulang, dan alur peninjauan.', 'dmca'),
	},
};

export function pickTdk(pageKey, locale) {
	const p = tdk[pageKey];
	if (!p) return tdk.home.en;
	return p[locale] || p.en;
}
